/*
  Far & Away bundles landing page (sections/fa-lp-*.liquid).
  Plain JavaScript, no dependencies. Reproduces the behaviour of the former Replo page:
  collapsibles, carousels (arrows, dots, thumbnails, swipe), hover states, the bundle
  selector (set tabs, colour swatches, prices, images), add to cart through the theme's
  own cart drawer, the "Meet the Makers" video player and the scroll-to buttons.
  Prices are formatted in the active presentment currency and the delivery thresholds are
  converted for currencies without fixed amounts (see sections/fa-lp-bundle.liquid).
*/
(function () {
  'use strict';

  var all = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var classes = function (el, add, remove) {
    (remove || '').split(' ').forEach(function (c) { if (c) el.classList.remove(c); });
    (add || '').split(' ').forEach(function (c) { if (c) el.classList.add(c); });
  };

  /* Money formatting. The bundle section renders 123456 cents through Liquid's money filter
     (data-fa-money-sample, e.g. "€1.234,56", "£1,234.56", "$1,234.56") and the prefix, separators
     and suffix are read from it, so prices re-rendered here match the server-rendered ones in
     every presentment currency. Without a sample the US format ("$1,234.56") is used. */
  var money = { prefix: '$', thousands: ',', decimal: '.', decimals: true, suffix: '' };
  function learnMoney(sample) {
    var m = sample && sample.match(/^(\D*)1(\D*)234(?:(\D*)56)?(\D*)$/);
    if (!m) return;
    money = { prefix: m[1], thousands: m[2], decimal: m[3] || '', decimals: !!m[3], suffix: m[4] };
  }
  function formatMoney(cents, fmt) {
    var n = (Number(cents) || 0) / 100;
    var parts = (money.decimals ? n.toFixed(2) : String(Math.round(n))).split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, money.thousands);
    var dec = parts[1] || '';
    if (fmt === 'nz' && /^0*$/.test(dec)) dec = ''; // money_without_trailing_zeros drops ",00"
    return money.prefix + whole + (dec ? money.decimal + dec : '') + money.suffix;
  }

  /* Delivery copy in presentment currencies other than the store currency (and GBP, which has
     fixed amounts): convert the store-currency thresholds at Shopify.currency.rate, formatted the
     same way as faApplyFreeShipping() in the theme's snippets/render.liquid. */
  function initDelivery(scope) {
    all('[data-fa-ship-convert]', scope).forEach(function (section) {
      var cur = window.Shopify && window.Shopify.currency;
      var rate = cur ? parseFloat(cur.rate) : NaN;
      if (!cur || !cur.active || !(rate > 0)) return;
      var symbols = { CHF: 'CHF ', CZK: 'Kč ', DKK: 'kr ', HUF: 'Ft ', PLN: 'zł ', SEK: 'kr ', USD: '$', EUR: '€', GBP: '£' };
      var fmt = function (base) {
        var v = Math.round(base * rate * 100) / 100;
        return (symbols[cur.active] || cur.active + ' ') + (v % 1 === 0 ? String(v) : v.toFixed(2));
      };
      var free = parseFloat(section.getAttribute('data-fa-ship-free-base'));
      var cost = parseFloat(section.getAttribute('data-fa-ship-cost-base'));
      if (free > 0) all('[data-fa-ship="free"]', section).forEach(function (el) { el.textContent = fmt(free); });
      if (cost > 0) all('[data-fa-ship="cost"]', section).forEach(function (el) { el.textContent = fmt(cost); });
    });
  }

  /* ---------------- Collapsibles ---------------- */
  function initCollapsibles(scope) {
    all('[data-fa-coll]', scope).forEach(function (coll) {
      if (coll.__fa) return; coll.__fa = true;
      var trigger = coll.querySelector('[data-fa-coll-trigger]');
      var content = coll.querySelector('[data-fa-coll-content]');
      if (!trigger || !content) return;
      var toggle = function () {
        var open = trigger.getAttribute('aria-expanded') !== 'true';
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        coll.setAttribute('data-fa-open', open ? 'true' : 'false');
        if (open) content.removeAttribute('hidden'); else content.setAttribute('hidden', '');
        all('[data-fa-open-add],[data-fa-open-rm]', trigger).concat(trigger.matches('[data-fa-open-add],[data-fa-open-rm]') ? [trigger] : []).forEach(function (el) {
          var add = el.getAttribute('data-fa-open-add') || '', rm = el.getAttribute('data-fa-open-rm') || '';
          if (open) classes(el, add, rm); else classes(el, rm, add);
        });
        all('path[data-fa-d-open]', trigger).forEach(function (p) {
          if (!p.hasAttribute('data-fa-d-closed')) p.setAttribute('data-fa-d-closed', p.getAttribute('d'));
          p.setAttribute('d', open ? p.getAttribute('data-fa-d-open') : p.getAttribute('data-fa-d-closed'));
        });
      };
      trigger.addEventListener('click', toggle);
      trigger.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
    });
  }

  /* ---------------- Hover states ---------------- */
  function initHover(scope) {
    all('[data-fa-hover-add],[data-fa-hover-rm]', scope).forEach(function (el) {
      if (el.__faHover) return; el.__faHover = true;
      var add = el.getAttribute('data-fa-hover-add') || '';
      var rm = (el.getAttribute('data-fa-hover-rm') || '').split(' ').filter(Boolean);
      el.addEventListener('mouseenter', function () {
        el.__faRemoved = rm.filter(function (c) { return el.classList.contains(c); });
        el.__faHovering = true;
        classes(el, add, el.__faRemoved.join(' '));
      });
      el.addEventListener('mouseleave', function () {
        el.__faHovering = false;
        classes(el, '', add);
        (el.__faRemoved || []).forEach(function (c) { if (!el.__faStateOff || el.__faStateOff.indexOf(c) < 0) el.classList.add(c); });
        el.__faRemoved = []; el.__faStateOff = null;
        if (el.__faRestore) el.__faRestore();
      });
    });
  }

  /* ---------------- Carousels ---------------- */
  function Carousel(root) {
    this.root = root;
    this.index = 0;
    this.viewports = all('[data-fa-part="slides"]', root);
    this.prev = all('[data-fa-part="nav-button"][data-fa-dir="previous"]', root);
    this.next = all('[data-fa-part="nav-button"][data-fa-dir="next"]', root);
    this.dots = all('[aria-label^="Go to slide"]', root);
    this.live = root.querySelector('.fa-lp-sr-only');
    // active classes of dots = classes on the first (active) dot that the second one lacks
    this.dotActive = [];
    if (this.dots.length > 1) {
      var a = this.dots[0].classList, b = this.dots[1].classList;
      for (var i = 0; i < a.length; i++) if (!b.contains(a[i])) this.dotActive.push(a[i]);
    }
    var self = this;
    this.prev.forEach(function (b) { b.addEventListener('click', function () { self.go(self.index - 1); }); });
    this.next.forEach(function (b) { b.addEventListener('click', function () { self.go(self.index + 1); }); });
    this.dots.forEach(function (d, i) {
      d.addEventListener('click', function () { self.go(i); });
      d.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); self.go(i); } });
    });
    this.viewports.forEach(function (vp) { self.swipe(vp); });
    window.addEventListener('resize', function () { self.go(self.index, true); });
  }
  Carousel.prototype.metrics = function (vp) {
    var track = vp.querySelector('[data-fa-part="slide-track"]');
    if (!track || !vp.offsetWidth) return null;
    var slides = all(':scope > [data-fa-part="slide"]', track);
    if (!slides.length) return null;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var w = slides[0].getBoundingClientRect().width;
    var vw = vp.getBoundingClientRect().width;
    var perPage = Math.max(1, Math.round((vw + gap) / (w + gap)));
    var center = vp.getAttribute('data-fa-align') === 'center';
    return { track: track, slides: slides, step: w + gap, max: Math.max(0, slides.length - perPage), offset: center ? (vw - w) / 2 : 0, count: slides.length };
  };
  Carousel.prototype.count = function () {
    var n = 0; this.viewports.forEach(function (vp) { var m = this.metrics(vp); if (m) n = Math.max(n, m.max); }, this); return n;
  };
  Carousel.prototype.go = function (i, instant) {
    var max = this.count();
    if (this.dots.length) max = Math.max(max, 0);
    i = Math.max(0, Math.min(i, max));
    this.index = i;
    this.viewports.forEach(function (vp) {
      var m = this.metrics(vp); if (!m) return;
      var idx = Math.min(i, m.max);
      m.track.style.transitionProperty = instant ? 'none' : 'transform';
      m.track.style.transitionDuration = instant ? '0ms' : '250ms';
      m.track.style.transitionTimingFunction = 'ease';
      // Same rounding as the Replo carousel: move by the slide's own (integer) offsetLeft.
      var x = m.slides[idx] ? m.slides[idx].offsetLeft - m.slides[0].offsetLeft : idx * m.step;
      m.track.style.transform = 'translate3d(' + (-x + Math.round(m.offset)) + 'px, 0px, 0px)';
      m.slides.forEach(function (s, k) { if (k === idx) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); });
    }, this);
    var self = this;
    this.prev.forEach(function (b) { self.disable(b, i <= 0); });
    this.next.forEach(function (b) { if (b.hasAttribute('data-fa-dis')) self.disable(b, i >= max); });
    this.dots.forEach(function (d, k) {
      self.dotActive.forEach(function (c) { d.classList.toggle(c, k === i); });
      d.setAttribute('aria-current', k === i ? 'true' : 'false');
    });
    if (this.live) this.live.textContent = 'Slide ' + (i + 1) + ' of ' + (this.maxSlides() || 1);
  };
  Carousel.prototype.maxSlides = function () {
    var n = 0; this.viewports.forEach(function (vp) { var t = vp.querySelector('[data-fa-part="slide-track"]'); if (t) n = Math.max(n, t.children.length); }); return n;
  };
  Carousel.prototype.disable = function (btn, off) {
    var cls = btn.getAttribute('data-fa-dis');
    if (cls) btn.classList.toggle(cls, off);
    if (off) btn.setAttribute('disabled', ''); else btn.removeAttribute('disabled');
  };
  Carousel.prototype.swipe = function (vp) {
    var self = this, startX = 0, startY = 0, dx = 0, active = false, horizontal = null, base = 0, m = null;
    var down = function (x, y) { m = self.metrics(vp); if (!m) return; active = true; horizontal = null; startX = x; startY = y; dx = 0;
      var cur = new DOMMatrixReadOnly(getComputedStyle(m.track).transform); base = cur.m41; };
    var move = function (x, y, e) {
      if (!active) return;
      dx = x - startX; var dy = y - startY;
      if (horizontal === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) horizontal = Math.abs(dx) > Math.abs(dy);
      if (!horizontal) return;
      if (e && e.cancelable) e.preventDefault();
      m.track.style.transitionProperty = 'none'; m.track.style.transitionDuration = '0ms';
      m.track.style.transform = 'translate3d(' + (base + dx) + 'px, 0px, 0px)';
    };
    var up = function () {
      if (!active) return; active = false;
      if (!horizontal) return;
      var threshold = Math.min(60, (m ? m.step : 300) * 0.2);
      if (dx < -threshold) self.go(self.index + 1); else if (dx > threshold) self.go(self.index - 1); else self.go(self.index);
      vp.__faDragged = Math.abs(dx) > 6;
    };
    vp.addEventListener('touchstart', function (e) { var t = e.touches[0]; down(t.clientX, t.clientY); }, { passive: true });
    vp.addEventListener('touchmove', function (e) { var t = e.touches[0]; move(t.clientX, t.clientY, e); }, { passive: false });
    vp.addEventListener('touchend', up);
    vp.addEventListener('touchcancel', up);
    vp.addEventListener('mousedown', function (e) { if (e.button !== 0) return; down(e.clientX, e.clientY); e.preventDefault(); });
    window.addEventListener('mousemove', function (e) { move(e.clientX, e.clientY); });
    window.addEventListener('mouseup', up);
    vp.addEventListener('click', function (e) { if (vp.__faDragged) { e.preventDefault(); e.stopPropagation(); vp.__faDragged = false; } }, true);
  };

  /* ---------------- Bundle selector ---------------- */
  function initBundle(section) {
    var parent = section.querySelector('[data-fa-bundle]');
    if (!parent) return;
    var states = JSON.parse(parent.getAttribute('data-fa-states') || '{}');
    learnMoney(parent.getAttribute('data-fa-money-sample'));
    var stateClasses = Object.keys(states).map(function (k) { return states[k]; }).filter(Boolean);

    all('[data-fa-product]', parent).forEach(function (box) {
      var data;
      try { data = JSON.parse(box.querySelector('[data-fa-data]').textContent); } catch (e) { return; }
      var form = box.querySelector('[data-fa-form]');
      var carouselRoot = box.querySelector('[data-fa-carousel]');
      var carousel = carouselRoot && carouselRoot.__faCarousel;
      var options = all('[data-fa-swatches] [role="option"]', box);
      var selectedCls = [];
      var sel = options.filter(function (o) { return o.getAttribute('aria-selected') === 'true'; })[0];
      var other = options.filter(function (o) { return o !== sel; })[0];
      if (sel && other) for (var i = 0; i < sel.classList.length; i++) if (!other.classList.contains(sel.classList[i])) selectedCls.push(sel.classList[i]);
      var current = data.variants.filter(function (v) { return v.id === data.variant; })[0] || data.variants[0];

      function setImages(color) {
        var list = data.images[color];
        if (!list) return;
        all('[data-fa-part="slide-track"]', box).forEach(function (track) {
          all(':scope > [data-fa-part="slide"]', track).forEach(function (slide, k) {
            var src = list[k]; if (!src) return;
            var pic = slide.querySelector('picture');
            if (pic) pic.style.setProperty('--fa-lp-attributes-currentitem', 'url("' + src + '")');
            all('source', slide).forEach(function (s) {
              var w = (s.getAttribute('srcset') || '').match(/[?&]width=\d+/);
              s.setAttribute('srcset', src + (w ? (src.indexOf('?') > -1 ? '&' : '?') + w[0].slice(1) : ''));
            });
            var img = slide.querySelector('img'); if (img) img.setAttribute('src', src);
          });
        });
        all('[aria-label^="Go to slide"]', box).forEach(function (d, k) {
          if (list[k]) d.style.setProperty('--fa-lp-attributes-currentitem', 'url("' + list[k] + '")');
        });
      }

      function render(variant) {
        current = variant;
        if (form) form.querySelector('[name="id"]').value = variant.id;
        all('[data-fa-compare]', box).forEach(function (el) { (el.querySelector('span') || el).textContent = formatMoney(variant.compare, el.getAttribute('data-fa-fmt')); });
        all('[data-fa-price]', box).forEach(function (el) { (el.querySelector('span') || el).textContent = formatMoney(variant.price, el.getAttribute('data-fa-fmt')); });
        all('[data-fa-diff]', box).forEach(function (el) { (el.querySelector('span') || el).textContent = formatMoney(variant.compare - variant.price, el.getAttribute('data-fa-fmt')); });
        all('[data-fa-color-label]', box).forEach(function (el) { (el.querySelector('span') || el).textContent = variant.color; });
        all('shopify-payment-terms', box).forEach(function (el) { el.setAttribute('data-amount', variant.price); });
        all('[data-fa-oos-class]', box).forEach(function (el) { el.classList.toggle(el.getAttribute('data-fa-oos-class'), !variant.available); });
        options.forEach(function (o) {
          var on = o.getAttribute('data-fa-value') === variant.color;
          o.setAttribute('aria-selected', on ? 'true' : 'false');
          if (o.__faHovering) { // hover state hides the selected state until the pointer leaves
            o.__faRemoved = on ? selectedCls.slice() : [];
          } else selectedCls.forEach(function (c) { o.classList.toggle(c, on); });
        });
      }

      options.forEach(function (o) {
        var pick = function () {
          var v = data.variants.filter(function (x) { return x.color === o.getAttribute('data-fa-value'); })[0];
          if (!v || v === current) return;
          render(v); setImages(v.color);
          if (carousel) carousel.go(0, true);
        };
        o.addEventListener('click', pick);
        o.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
      });

      all('[data-fa-tab]', box).forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-fa-tab');
          stateClasses.forEach(function (c) { parent.classList.remove(c); });
          if (states[key]) parent.classList.add(states[key]);
          var target = parent.querySelector('[data-fa-product][data-fa-key="' + key + '"]');
          if (target && target.__faCarousel) target.__faCarousel.go(target.__faCarousel.index, true);
          window.requestAnimationFrame(function () { all('[data-fa-carousel]', parent).forEach(function (c) { if (c.__faCarousel) c.__faCarousel.go(c.__faCarousel.index, true); }); });
        });
      });

      all('[data-fa-atc]', box).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          addToCart(current.id, 1, form);
        });
      });

      var title = box.querySelector('[data-fa-href]');
      if (title) {
        var openTitle = function () { window.open(title.getAttribute('data-fa-href'), '_blank'); };
        title.addEventListener('click', openTitle);
        title.addEventListener('keydown', function (e) { if (e.key === 'Enter') openTitle(); });
      }
      box.__faRender = render;
    });
  }

  function addToCart(id, qty, form) {
    var loader = document.querySelector('.loader');
    if (loader) loader.classList.remove('hide_loader');
    var done = function () { if (loader) loader.classList.add('hide_loader'); };
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      return r.json();
    }).then(function () {
      // Same path as the theme's own product page: refresh the cart drawer and open it.
      if (typeof window.updatecartnew === 'function') window.updatecartnew('/cart/update');
      else { done(); window.location.href = root + 'cart'; }
    }).catch(function () {
      done();
      if (form) form.submit();
    });
  }

  /* ---------------- Video player (Meet the Makers) ---------------- */
  function initVideo(box) {
    var video = box.querySelector('video');
    if (!video) return;
    var play = box.querySelector('[data-fa-video-play]');
    var mute = box.querySelector('[data-fa-video-mute]');
    var fs = box.querySelector('[data-fa-video-fs]');
    var overlay = box.querySelector('[data-fa-video-overlay]');
    var swap = function (btn, alt) {
      var svg = btn.querySelector('svg'); if (!svg) return;
      if (!btn.__faSvg) btn.__faSvg = svg.innerHTML;
      svg.innerHTML = alt ? btn.getAttribute('data-fa-svg-alt') : btn.__faSvg;
    };
    var start = function () {
      if (!video.getAttribute('src') && video.getAttribute('data-fa-src')) video.setAttribute('src', video.getAttribute('data-fa-src'));
      if (overlay && overlay.parentNode) overlay.parentNode.removeChild(overlay);
      video.play();
    };
    var toggle = function () { if (video.paused) start(); else video.pause(); };
    video.addEventListener('play', function () { if (play) { swap(play, true); play.setAttribute('aria-label', 'Pause'); } });
    video.addEventListener('pause', function () { if (play) { swap(play, false); play.setAttribute('aria-label', 'Play'); } });
    if (play) play.addEventListener('click', toggle);
    if (overlay) overlay.addEventListener('click', start);
    video.addEventListener('click', toggle);
    if (mute) mute.addEventListener('click', function () {
      video.muted = !video.muted;
      swap(mute, video.muted);
      mute.setAttribute('aria-label', video.muted ? 'Unmute' : 'Mute');
    });
    if (fs) fs.addEventListener('click', function () {
      var el = video;
      if (document.fullscreenElement) document.exitFullscreen();
      else if (el.requestFullscreen) el.requestFullscreen();
      else if (el.webkitEnterFullscreen) el.webkitEnterFullscreen();
    });
    [play, mute, fs].forEach(function (b) {
      if (b) b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); b.click(); } });
    });
  }

  /* ---------------- Scroll buttons ---------------- */
  function initScroll(scope) {
    all('[data-fa-scroll]', scope).forEach(function (el) {
      if (el.__faScroll) return; el.__faScroll = true;
      el.addEventListener('click', function (e) {
        var target = document.querySelector(el.getAttribute('data-fa-scroll'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init() {
    var scope = document;
    initCollapsibles(scope);
    initHover(scope);
    all('[data-fa-carousel]', scope).forEach(function (c) {
      if (c.__faCarousel) return;
      c.__faCarousel = new Carousel(c);
      var box = c.closest('[data-fa-product]'); if (box) box.__faCarousel = c.__faCarousel;
    });
    all('[data-fa-section="bundle"]', scope).forEach(initBundle);
    all('[data-fa-video]', scope).forEach(initVideo);
    initScroll(scope);
    initDelivery(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
